import script from "./CommFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./CommFooter.vue?vue&type=script&setup=true&lang=js"

import "./CommFooter.vue?vue&type=style&index=0&id=677d000c&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-677d000c"]])

export default __exports__